import { Card, CardContent, Skeleton, Box } from '@mui/material';

function ArtworkSkeleton() {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Skeleton variant="rectangular" height={200} />
      <CardContent sx={{ flexGrow: 1 }}>
        <Skeleton variant="text" height={40} width="60%" />
        <Skeleton variant="text" height={20} width="90%" />
        <Skeleton variant="text" height={20} width="80%" />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Skeleton variant="text" height={30} width={80} />
          <Skeleton variant="rectangular" height={36} width={120} />
        </Box>
      </CardContent>
    </Card>
  );
}

export default ArtworkSkeleton;